import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';
let drilldownControllerRef = null;

const getContactsCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/contacts/card`, params);
  return hireCardResponse;
};

const getContactsChartAndTable = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(
    `/reports/contacts/chart_table`,
    params
  );
  return hireCardResponse;
};

const getContactsVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const offerResponse = atsHttp.post(`/reports/contacts/visual`, params);
  return offerResponse;
};

const getContactDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {} },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      compare: false,
    });
    const response = await atsHttp.post(`/reports/contacts/drilldown`, params, {
      signal: controller.signal,
    });
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchContactsCard = createAsyncThunk(
  'ats-reports/contacts/card',
  getContactsCard
);

export const fetchContactsTable = createAsyncThunk(
  'ats-reports/contacts/table',
  getContactsChartAndTable
);

export const fetchContactsChart = createAsyncThunk(
  'ats-reports/contacts/chart',
  getContactsChartAndTable
);

export const fetchContactsBySource = createAsyncThunk(
  'ats-reports/contacts/visual-by-source',
  getContactsVisual
);

export const fetchContactsByGender = createAsyncThunk(
  'ats-reports/contacts/visual-by-gender',
  getContactsVisual
);

export const fetchContactDrilldown = createAsyncThunk(
  'ats-reports/contacts/drilldown',
  getContactDrilldown
);

// export const fetchOfferByRejectionReason = createAsyncThunk(
//   'ats-reports/offers/rejection/source',
//   getRejectionReason
// );
